import * as React from 'react';
import { connect } from 'react-redux';
import { getNextStep } from '../../../../actions/claimHistoryActionsV2'
import { ProgressBar } from 'react-bootstrap';
import { showEstimatedDateChanged, showEstimatedTime, showEstimatedTimeForEachStep } from '../../../../actions/modalActions';
import { Image } from "react-bootstrap";


class ClaimsProgressBar extends React.Component<any, any> {

    private progressBarNumber: number = 0;
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleShowEstimate = this.handleShowEstimate.bind(this);
        this.getClaimProgressBarValue = this.getClaimProgressBarValue.bind(this);
        this.getFormatDate = this.getFormatDate.bind(this);
        this.handleShowEstimateForEachStep = this.handleShowEstimateForEachStep.bind(this);
    }

    async handleClick() {
        this.props.handleGetNextStep();
    }

    async handleShowEstimateForEachStep() {
        if (this.props.claimSubmit.selectedClaimProgressStep.ecdChanged === 1) {
            this.props.handleShowEstimatedDateChanged();
        }
        else {
            this.props.handleShowEstimatedTimeEachStep();
        }
    }

    async handleShowEstimate() {
        if (this.props.claimSubmit.selectedClaimProgressStep.ecdChanged === 1) {
            this.props.handleShowEstimatedDateChanged();
        }
        else {
            this.props.handleShowEstimatedTime();
        }
    }

    getClaimProgressBarValue() {
        var stepsList = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.overallEstProgressBar !== null)
        if (stepsList.length > 0 && stepsList[0].overallEstProgressBar) {
            this.progressBarNumber = stepsList[0].overallEstProgressBar;
        }
    }

    getClaimStatusClass(claimStatus) {
        let cssClass = '';
        switch (claimStatus) {
            case 'Approved': cssClass = 'Approved'
                break;
            case 'Not approved': cssClass = 'Cancelled';
                break;
            case 'Pending': cssClass = 'Pending';
                break;
            default: cssClass = 'hidden';
        }
        return cssClass;
    }

    getFormatDate(date: string) {
        if (date) {
            const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var stringDate = date.split('T')[0];
            var formatedDate = new Date(stringDate);
            var fullFormatedDate = formatedDate.getDate().toString() + " " + monthNames[formatedDate.getMonth()] + " " + formatedDate.getFullYear().toString();
            return fullFormatedDate;
        }
        return "Not Found";
    }

    render() {
        this.getClaimProgressBarValue();
        const claimStepDescription = this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase();
        const claimStep = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.claimStepDescription.toLowerCase() === claimStepDescription)[0];
        const stepsList = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.overallEstProgressBar !== null).length > 0

        return (
            <>
                {stepsList === true && claimStepDescription && (claimStep.overallEstCompletionDate || claimStep.overallEstLatestDate) &&
                    <>
                        <div className="row noma">
                            <div className="claims-progress-col nopa">
                                {claimStepDescription && claimStepDescription === "overview" && (claimStep.overallEstCompletionDate || claimStep.overallEstLatestDate) &&
                                    <p className="mb-0px"><b>Overall estimated completion date</b>
                                        <span className="claims-margin-left"><Image onClick={() => this.handleShowEstimate()} className="completionTooltip cursor" id="completionTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="raftool" data-tip="" /></span>
                                    </p>
                                }
                                {claimStepDescription && (claimStepDescription !== "overview") &&
                                    <p className="mb-0px"><b>Estimated completion date for this step</b>
                                    <span className="claims-margin-left"><Image onClick={() => this.handleShowEstimateForEachStep()} className="completionTooltip cursor" id="completionTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="raftool" data-tip="" /></span>
                                    </p>
                                }
                            </div>

                            {claimStepDescription && (claimStep.overallEstCompletionDate || claimStep.overallEstLatestDate) && claimStepDescription === "overview" &&
                                <div className="claim-step-col">
                                    {claimStep.overallEstCompletionDate && <p className={((claimStepDescription !== "overview") ? "text-red " : "") + "text-lg-right mb-5px font-weight-500"}><b>{this.getFormatDate(claimStep.overallEstCompletionDate)}</b></p>}
                                    {claimStep.overallEstCompletionDate && claimStep.overallEstLatestDate && <p className="pull-lg-right Or-latest mb-0px">Or latest {this.getFormatDate(claimStep.overallEstLatestDate)}</p>}
                                    {!claimStep.overallEstCompletionDate && claimStep.overallEstLatestDate && <p className="pull-lg-right Or-latest mb-0px">latest {this.getFormatDate(claimStep.overallEstLatestDate)}</p>}
                                </div>
                            }
                            {claimStepDescription && (claimStep.stepEstCompletionDate || claimStep.stepEstLatestDate) && claimStepDescription !== "overview" &&
                                <div className="claim-step-col">
                                    {claimStep.stepEstCompletionDate && <p className={((claimStepDescription !== "overview") ? "text-red " : "") + "text-lg-right mb-5px font-weight-500"}><b>{this.getFormatDate(claimStep.stepEstCompletionDate)}</b></p>}
                                    {claimStep.stepEstCompletionDate && claimStep.stepEstLatestDate && <p className="pull-lg-right Or-latest mb-0px">Or latest {this.getFormatDate(claimStep.stepEstLatestDate)}</p>}
                                    {!claimStep.stepEstCompletionDate && claimStep.stepEstLatestDate && <p className="pull-lg-right Or-latest mb-0px">latest {this.getFormatDate(claimStep.stepEstLatestDate)}</p>}
                                </div>
                            }
                        </div>
                        <div className="mt-15px">
                            {claimStepDescription && (claimStep.overallEstCompletionDate || claimStep.overallEstLatestDate) &&
                                <ProgressBar id="claimProgress" now={this.progressBarNumber} />
                            }
                        </div>
                    </>
                }
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleGetNextStep: () => dispatch(getNextStep()),
        handleShowEstimatedTime: () => dispatch(showEstimatedTime()),
        handleShowEstimatedTimeEachStep: () => dispatch(showEstimatedTimeForEachStep()),
        handleShowEstimatedDateChanged: () => dispatch(showEstimatedDateChanged()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimsProgressBar);
